var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
import { LayoutNavigation } from "./LayoutNavigation";
import { useLayoutConfig } from "./LayoutProvider";
var styles = bem("rmd-layout-mini-wrapper");
/**
 * This is probably an internal only component.
 *
 * @remarks \@since 2.8.3
 */
export function MiniLayoutWrapper(_a) {
    var mini = _a.mini, miniHidden = _a.miniHidden, miniNav = _a.miniNav, miniNavItems = _a.miniNavItems, treeProps = _a.treeProps, header = _a.header, headerProps = _a.headerProps, headerTitle = _a.headerTitle, headerTitleProps = _a.headerTitleProps, closeNav = _a.closeNav, closeNavProps = _a.closeNavProps, children = _a.children, containerProps = _a.containerProps, props = __rest(_a, ["mini", "miniHidden", "miniNav", "miniNavItems", "treeProps", "header", "headerProps", "headerTitle", "headerTitleProps", "closeNav", "closeNavProps", "children", "containerProps"]);
    var _b = useLayoutConfig(), fixedAppBar = _b.fixedAppBar, isMiniable = _b.isMiniable;
    if ((!mini && !isMiniable) || !treeProps || typeof miniNav !== "undefined") {
        return (React.createElement(React.Fragment, null,
            miniNav,
            children));
    }
    var miniTreeProps = treeProps;
    if (miniNavItems) {
        miniTreeProps = __assign(__assign({}, miniTreeProps), { navItems: miniNavItems });
    }
    var miniNavigation = (React.createElement(LayoutNavigation, __assign({ header: header, headerProps: headerProps, headerTitle: headerTitle, headerTitleProps: headerTitleProps, closeNav: closeNav, closeNavProps: closeNavProps, treeProps: miniTreeProps }, props, { mini: true, sticky: !fixedAppBar, hidden: miniHidden })));
    if (fixedAppBar) {
        return (React.createElement(React.Fragment, null,
            miniNavigation,
            children));
    }
    return (React.createElement("div", __assign({}, containerProps, { className: cn(!miniHidden && mini && styles(), containerProps === null || containerProps === void 0 ? void 0 : containerProps.className) }),
        mini && miniNavigation,
        children));
}
//# sourceMappingURL=MiniLayoutWrapper.js.map